import { Box, BoxProps, Flex } from "@chakra-ui/react"
import styled from "@emotion/styled"
import React, { ReactNode } from "react"
import useWindowSize from "../../../hooks/useWindowSize"
import { isTouchDevice } from "../../../util/browser"

type ScrollbarStyles = {
  trackColor: string
  thumbColor: string
}

const Container = styled(Box)<ScrollbarStyles>`
  overflow-y: scroll;

  &::-webkit-scrollbar-track {
    background: ${({ trackColor }) => `${trackColor}`};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ thumbColor }) => `${thumbColor}`};
    border-radius: 10px;
    height: 5px;
    max-height: 10px;
  }
`

function StyledScrollableList({
  name,
  children,
  thumbColor,
  trackColor,
  ...rest
}: { children: ReactNode; name: string } & Partial<ScrollbarStyles> &
  BoxProps) {
  return (
    <Container
      thumbColor={thumbColor || "#412E2E"}
      trackColor={trackColor || "#0D0A04"}
      {...rest}
    >
      {children}
    </Container>
  )
}

export default StyledScrollableList

export const MaybeReactScrollMaybeNative = ({
  children,
  ...rest
}: {
  children: ReactNode
} & Partial<ScrollbarStyles> &
  BoxProps) => {
  const { screenSize } = useWindowSize()
  const isMobile = React.useMemo<boolean>(isTouchDevice, [screenSize])

  if (isMobile)
    return (
      <Flex
        className="naught-width-scrollbar"
        overflowY="scroll"
        overflowX="hidden"
        {...rest}
      >
        {children}
      </Flex>
    )

  return (
    <StyledScrollableList name="TopicsLevel" {...rest}>
      {children}
    </StyledScrollableList>
  )
}
